// import React from 'react';

// export const ResourcesContext = React.createContext({
//     logos: {
//         pokemonrift: require('../assets/images/pokemonrift.jpg'),
//         pulpacolada: require('../assets/images/pulpacolada.jpg'),
//         iwm: require('../assets/logos/iwm.jpg'),
//         autonumgo: require('../assets/images/autonumgo.jpg'),
//         iwmintranet: require('../assets/logos/iwmintranet.jpg'),
//         // campingsimulator: require(''),
//         orkestra: require('../assets/images/orkestra.jpg'),
//         instorm: require('../assets/logos/instorm.jpg'),
//         // runner: (''),
//     },
//     images: {
//         pulpacolada: require('../assets/images/pulpacolada.jpg'),
//         iwm: require('../assets/images/iwm.jpg'),
//         autonumgo: require('../assets/images/autonumgo.jpg'),
//         iwmintranet: require('../assets/images/iwmintranet.jpg'),
//         // campingsimulator: require(''),
//         orkestra: require('../assets/images/orkestra.jpg'),
//     },
//     videos: {
//         instorm: require('../assets/videos/instorm.mov'),
//         runner: require('../assets/videos/runner.mov'),
//     }
// });

export const Resources = {
    logos: {
        pokemonrift: require('../assets/images/pokemonrift.jpg'),
        pulpacolada: require('../assets/logos/pulpacolada.jpg'),
        iwm: require('../assets/logos/iwm.jpg'),
        autonumgo: require('../assets/logos/autonumgo.jpg'),
        iwmintranet: require('../assets/logos/iwmintranet.jpg'),
        campingsimulator: require('../assets/logos/campingsimulator.jpg'),
        orkestra: require('../assets/logos/orkestra.jpg'),
        instorm: require('../assets/logos/instorm.jpg'),
        runner: require('../assets/logos/runner.jpg'),
    },
    images: {
        pulpacolada: require('../assets/images/pulpacolada.jpg'),
        iwm: require('../assets/images/iwm.jpg'),
        autonumgo: require('../assets/images/autonumgo.jpg'),
        iwmintranet: require('../assets/images/iwmintranet.jpg'),
        campingsimulator: require('../assets/images/campingsimulator.jpg'),
        orkestra: require('../assets/images/orkestra.jpg'),
    },
};